var React = require('react');

function WellDone (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"60","cy":"60","r":"60","fill":"#F9F9FD","key":0}),React.createElement("path",{"d":"M81.5798 42H76.1681C74.9911 42 73.8719 42.5654 73.1795 43.5347L55.0405 68.6893L46.8248 57.289C46.1325 56.3312 45.0248 55.7543 43.8363 55.7543H38.4246C37.6745 55.7543 37.2361 56.6082 37.6745 57.2197L52.0519 77.1588C52.3916 77.6329 52.8393 78.0192 53.358 78.2856C53.8768 78.5521 54.4515 78.6911 55.0347 78.6911C55.6179 78.6911 56.1927 78.5521 56.7114 78.2856C57.2301 78.0192 57.6779 77.6329 58.0175 77.1588L82.3183 43.4654C82.7683 42.8539 82.3298 42 81.5798 42Z","fill":"#02CCCB","key":1})]);
}

WellDone.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120","fill":"none"};

module.exports = WellDone;

WellDone.default = WellDone;
